<template>
	<el-dialog :visible.sync="is_visible" :width="'70%'" @close="close" :modal="false">
		<template slot="title">
			<div>
				<h3 class="mb-0 font-weight-500">Simulate Case Loan Calculator</h3>
			</div>
		</template>
		<b-container>
			<el-collapse v-model="activeSections">
				<el-collapse-item name="summary" class="my-3">
					<div slot="title" class="collapse-header">
						<h3 class="mb-0">Calculation Summary</h3>
					</div>
					<b-row class="m-3">
						<b-col cols="12">
							<b-card-group deck>
								<b-card>
									<div >
										<p class="text-muted text-xs">Loan Amount</p>
										<p class="font-weight-600">RM {{ _gHlp.getValue(newLoanDetail, 'loan_amount', 0) | moneyFormatter }}
										</p>
									</div>
									<div >
										<p class="text-muted text-xs">Interest Rate</p>
										<p class="font-weight-600">{{ _gHlp.getValue(newLoanDetail, 'interest_rate', 0) }} %</p>
									</div>
									<div >
										<p class="text-muted text-xs">Interest Amount</p>
										<p class="font-weight-600">RM {{ _gHlp.getValue(newLoanDetail, 'total_interest_amt', 0) | moneyFormatter }}
										</p>
									</div>
								</b-card>
								<b-card>
									<div >
										<p class="text-muted text-xs">Installment Amount</p>
										<p class="font-weight-600">RM {{ _gHlp.getValue(newLoanDetail, 'installment_amount', 0) | moneyFormatter }}
										</p>
									</div>
									<div >
										<p class="text-muted text-xs">Total Amount Paid</p>
										<p class="font-weight-600">RM {{ parseFloat(_gHlp.getValue(newLoanDetail, 'loan_amount', 0)) + parseFloat(_gHlp.getValue(newLoanDetail, 'total_interest_amt', 0)) | moneyFormatter
											}}
										</p>
									</div>
									<div >
										<p class="text-muted text-xs">Credit Loan DC Amount</p>
										<p class="font-weight-600">RM {{ debt_console_amount | moneyFormatter }} </p>
									</div>
								</b-card>
								<b-card>
									<div >
										<p class="text-muted text-xs">Moratorium Tenure</p>
										<p class="font-weight-600">{{ _gHlp.getValue(newLoanDetail, 'moratorium_tenure', 0) }} </p>
									</div>
									<div >
										<p class="text-muted text-xs">Moratorium Installment</p>
										<p class="font-weight-600">RM {{ _gHlp.getValue(newLoanDetail, 'moratorium_inst', 0) |
											moneyFormatter }} </p>
									</div>
									<div >
										<p class="text-muted text-xs">Moratorium Start Period</p>
										<p class="font-weight-600">{{ _gHlp.getValue(newLoanDetail, 'moratorium_start', 0) }} </p>
									</div>
								</b-card>
							</b-card-group>
						</b-col>
					</b-row>
				</el-collapse-item>
				<el-collapse-item name="repayments" class="my-3">
					<div slot="title" class="collapse-header">
						<h3 class="mb-0">Repayments Rule 78</h3>
					</div>
					<div class="table-simple">
						<b-table-simple responsive class="mb-0">
							<b-thead>
								<b-tr>
									<b-th class="text-white">Period</b-th>
									<b-th class="text-white">Column</b-th>
									<b-th class="text-white">Interest Charged(RM)</b-th>
									<b-th class="text-white">Principal(RM)</b-th>
									<b-th class="text-white">Installment(RM)</b-th>
									<b-th class="text-white">Balance(RM)</b-th>
								</b-tr>
							</b-thead>
							<b-tbody v-if="!_gHlp.isEmpty(repaymentList)">
								<b-tr v-for="(loan, index) in repaymentList" :key="index">
									<b-td>{{ loan.period }}</b-td>
									<b-td>{{ loan.column }}</b-td>
									<b-td>{{ loan.interest_charged | moneyFormatter }}</b-td>
									<b-td>{{ loan.principal | moneyFormatter }}</b-td>
									<b-td>{{ loan.installment | moneyFormatter }}</b-td>
									<b-td>{{ loan.balance | moneyFormatter }}</b-td>
								</b-tr>
							</b-tbody>
							<b-tbody v-else>
								<b-tr>
									<b-td colspan="6">No Record</b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</div>

				</el-collapse-item>

			</el-collapse>
		</b-container>
	</el-dialog>
</template>
<script>
import { Button, Dialog, Collapse, CollapseItem } from 'element-ui'
import { cloneDeep } from 'lodash'
import CurrencyInput from '@/components/CurrencyInput'
import { swal } from '@/assets/js/httpImports.js';
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore';

export default {
	// props: ['editData'],
	components: {
		CurrencyInput,
		[Button.name]: Button,
		[Dialog.name]: Dialog,
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem,
	},
	data() {
		return {
			is_visible: false,
			is_loading_btn: false,
			newLoanDetail: {},
			activeSections: ['summary', 'repayments']
		}
	},
	created() {
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeCase','activeDisbursements']),
		repaymentList() {
			return _gHlp.getValue(this.newLoanDetail, 'repayment_breakdown', [])
		},
		debt_console_amount(){
			let total = 0;
			if (!_gHlp.isEmpty(this.activeDisbursements)) {
				total = this.activeDisbursements.reduce((tot, obj) => {
					return (obj.description != 'Balance Disbursement') ? (tot + parseFloat(obj.amount)) : tot
				}, 0)
			}
			return parseFloat(total).toFixed(2);
		}
	},
	methods: {
		show(data) {
			this.newLoanDetail = data;
			this.is_loading_btn = false
			this.is_visible = true
		},
		close() {
			this.is_visible = false
			this.is_loading_btn = false,
			this.newLoanDetail = {}
		}
	}
}
</script>